import { connect } from 'react-redux';
import { IState } from '../../store';
import { DealRentEntryToShowButton } from './DealRentEntryToShowButton';
import { openEntryToShow } from '../../store/deal-rent';

export function mapStateToProps(state: IState) {
  const offer = state.offerData.offer;
  const isAvailable =
    Boolean(offer.flags && offer.flags.isDealRent && offer.dealType === 'rent') && state.entryToShowEnabled;

  return {
    isAvailable,
  };
}

export const DealRentEntryToShowButtonContainer = connect(mapStateToProps, { open: openEntryToShow })(
  DealRentEntryToShowButton,
);
